import React, { FC } from 'react';

interface BillingHeaderData {
  year: string;
  totale_quantita_prezzo: number;
}

interface BillingHeaderProps {
  className?: string;
  sumData: BillingHeaderData[];
  loading: boolean;
}

const BillingHeader: FC<BillingHeaderProps> = ({
  className = '',
  sumData = [],
  loading = false,
}) => {
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('it-IT', {
      maximumFractionDigits: 0,
    }).format(value);
  };

  const getTotalForYear = (year: string): number => {
    return (
      sumData.find((item) => item.year === year)?.totale_quantita_prezzo || 0
    );
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className={`flex justify-center items-start gap-5 mt-[25px] mb-[25px] ${className}`}>
      <div className="py-[24px] border-white flex items-center flex-col md:flex-row justify-center gap-[4rem]">
        {['2024', '2025', '2026'].map((year, idx) => (
          <React.Fragment key={year}>
            {idx !== 0 && (
              <div className="w-[1px] h-[180px] bg-slate-500 hidden md:block" />
            )}
            <div className="text-center min-w-[150px]">
              <p className="text-md mb-3">Fatturato {year}</p>
              <h2 className="text-3xl text-blue-600">
                {formatCurrency(getTotalForYear(year))}
              </h2>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default BillingHeader;
